import { ChatWidgetStylingSettingsData } from "@/TickApi";
import { deviceIsMobile } from "./deviceHelper";


export function generateStylingProperties(name: string, styling: ChatWidgetStylingSettingsData, defaultFont: string, defaultFontSize: number) {
  if (!styling) { styling = {}; }
  const properties = {};
  const defaultBg = "#efefef";
  const defaultFg = "#ffffff";
  const defaultBorderColor = "#efefef";
  const defaultBorderRadius = 3;
  const defaultBackgroundImageUrl = "";
  const defaultShowBorder = false;
  const transparent = "transparent";

  const prefix = name
    ? '--cw-'
    : '--cw'

  properties[prefix + name + '-bg-color'] = styling.showBackground ? (styling.backgroundColor || defaultBg) : transparent;
  properties[prefix + name + '-fg-color'] = styling.foregroundColor || defaultFg;
  properties[prefix + name + '-border-color'] = styling.borderColor || defaultBorderColor;
  properties[prefix + name + '-border-width'] = (styling.showBorder ? '1' : '0') + "px";
  properties[prefix + name + '-border-radius'] = generateBorderRadius(styling);
  properties[prefix + name + '-padding'] = generatePadding(styling);
  properties[prefix + name + '-font-family'] = styling.fontFamily || defaultFont;

  const fontSize = styling.fontSize ? styling.fontSize : defaultFontSize;

  if (!deviceIsMobile()) {
    properties[prefix + name + '-font-size'] = fontSize + 'px';
  } else {
    const defaultSize = 14;

    properties[prefix + name + '-font-size'] = (fontSize / defaultSize) + 'rem';
  }


  properties[prefix + name + '-drop-shadow'] = generateDropShadow(styling);

  return properties;
}

export function generatePadding(v: ChatWidgetStylingSettingsData) {
  if (!v || !v.useCustomPadding) { return "0"; }
  const unit = "px";
  return `${v.padding_LeftTop}${unit} ${v.padding_RightTop}${unit} ${v.padding_RightBottom}${unit} ${v.padding_LeftBottom}${unit}`;
}
export function generateDropShadow(v: ChatWidgetStylingSettingsData) {
  if (!v || !v.dropShadow) { return "none"; }

  const unit = "px";
  const shadowOpacity = v.dropShadow * 0.02;

  // -7px -9px 5px -3px rgba(0, 0, 0, 0.05);
  const bottomShadow = Math.round(v.dropShadow / 2);

  return `-${v.dropShadow}${unit} ${bottomShadow}${unit} ${v.dropShadow}${unit} 0${unit} rgba(0, 0, 0, ${shadowOpacity})`;
}


export default function generateBorderRadius(value: number | ChatWidgetStylingSettingsData): string {
  let valIsNumeric = typeof value === 'number';
  const stylingData = value as ChatWidgetStylingSettingsData;

  if (!valIsNumeric && (stylingData && (stylingData.borderRadius_Linked || stylingData.borderRadius_LeftTop == null))) {
    valIsNumeric = true;
    value = stylingData.borderRadius;
  }

  if (!value || valIsNumeric) {
    const radius = value as number || 0
    //if (radius > 0) { radius = radius / 20; }

    return `${radius}vmin`;
  } else {

    return stylingData.borderRadius_Linked
      ? generateBorderRadius(stylingData.borderRadius)
      : `${generateBorderRadius(stylingData?.borderRadius_LeftTop)} ${generateBorderRadius(stylingData?.borderRadius_RightTop)} ${generateBorderRadius(stylingData?.borderRadius_RightBottom)} ${generateBorderRadius(stylingData?.borderRadius_LeftBottom)}`
  }
}

